module.exports = __webpack_public_path__ + "img/wateMaxLoad.360e7797.png";